

const ContatoEnderecoFeagri = () => {
    // Componente responsável por mostrar contato e endereço da feagri
    return (
        <div className='font-normal'>
            <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Contato/Endereço</h2>

            <div>
                <p>Universidade Estadual de Campinas</p>
                <p>Faculdade de Engenharia Agrícola – <span className='font-semibold'>FEAGRI</span></p>
            </div>

            <div className='mt-4'>
                <p>Av. Cândido Rondon, 501 - Barão Geraldo</p>
                <p>13083-875 - Campinas/SP</p>
            </div>
        </div>
    );
}

export { ContatoEnderecoFeagri };